import React, {useEffect, useState} from 'react';
import {Checkbox, Col, theme, Typography} from 'antd';
import {fieldColProps} from '../gridHelpers';

const CustomCheckbox = (props) => {
  const {formikProp} = props;
  const checkBoxField = props.field;
  const [checked, setChecked] = useState(props.formikProp.values[checkBoxField.name]);
  const customEvents: any = props.customEvents
    ? props.customEvents[checkBoxField.name] && props.customEvents[checkBoxField.name]
    : {};
  const {token}: any = theme.useToken();

  useEffect(() => {
    setChecked(props.formikProp.values[checkBoxField.name]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.formikProp.values[checkBoxField.name]]);

  return (
    <Col
      xs={fieldColProps(checkBoxField).xs}
      sm={fieldColProps(checkBoxField).sm}
      style={{padding: 8, display: checkBoxField.isHidden ? 'none' : 'block'}}>
      <Checkbox
        name={checkBoxField.name}
        disabled={checkBoxField?.isDisabled || false}
        checked={checked}
        onChange={(e) => {
          formikProp.setFieldValue(checkBoxField.name, e.target.checked);
          setChecked(e.target.checked);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](e, formikProp.setFieldValue);
        }}>
        {/* `highLight` disabled checkboxes (e.g. "CB InEligible", "Last Booking")
            were warning-coloured in the old UI so agents notice them. */}
        <span
          style={
            checkBoxField?.highLight && checkBoxField?.isDisabled
              ? {color: token.colorWarningText}
              : undefined
          }>
          {checkBoxField.fieldLabel}
        </span>
      </Checkbox>
      {checked && checkBoxField.note ? (
        <Typography.Text style={{display: 'block', color: token.colorError}}>
          {checkBoxField.note}
        </Typography.Text>
      ) : (
        ''
      )}
    </Col>
  );
};

export default CustomCheckbox;
